import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { NonDeprecatedKeycloakService as KeycloakService } from "@core/keycloak/non-deprecated-keycloak.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { environment } from "@env/environment";

import { RouterModule, Router, NavigationEnd } from "@angular/router";
import { NavigationComponent } from "@layout/navigation/navigation.component";
import { FilterableSelectComponent } from "@layout/common/filterable-select/filterable-select.component";
import { Erfassungswelle } from "@core/erfassungswellen/erfassungswelle.model";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";

@Component({
  standalone: true,
  imports: [
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatButtonModule,
    FilterableSelectComponent,
    NavigationComponent,
    FlexLayoutModule,
  ],
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  // Use the default change detection strategy.  A global OnPush strategy
  // on the root component prevented some pages from updating their
  // content until a user interaction occurred.  With the default
  // strategy, asynchronous data and route transitions trigger change
  // detection automatically across the application.
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnDestroy, OnInit {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  public username: string;
  /**
   * Currently selected Erfassungswelle from the filter component.  The
   * filter may emit null when the selection is cleared, so make this
   * property nullable to avoid TS2322 errors.
   */
  private selectedErfassungswelle: Erfassungswelle | null = null;
  env = (environment as any).stage ?? "DEVELOPMENT";

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private keycloakService: KeycloakService,
    private router: Router,
  ) {
    this.username = this.keycloakService.getUsername() || "";
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    // Remove console output in production builds.  Logging environment
    // objects can inadvertently reveal sensitive information.  The
    // management-client did not log these values.
    // console.log(environment);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  selectedErfassungswelleChanged(erfassungswelle: Erfassungswelle | null) {
    this.selectedErfassungswelle = erfassungswelle;
    // trigger reload of data?
  }

  ngOnInit() {
    // Avoid debug logging in production.  Uncomment for local debugging if needed.
    // console.log('Debug mode is enabled');
    // console.log(environment.keycloak);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  }
}
